export default __webpack_public_path__ + "static/media/ff-monster.780765de.png";